(function () {
  /* rb-desktop-scale-v1: shared mobile gate — true touch only, not resized desktop */
  window.rbIsTouchMobile = function (maxWidth) {
    var max = typeof maxWidth === "number" ? maxWidth : 999;
    if (window.rbIsDesktopClient && window.rbIsDesktopClient()) return false;
    try {
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) return false;
    } catch (e) {}
    try {
      return window.matchMedia(
        "(max-width: " + max + "px) and (hover: none), (max-width: " + max + "px) and (pointer: coarse)"
      ).matches;
    } catch (e2) {
      return window.innerWidth <= max;
    }
  };
})();

(function () {
  var MOBILE_MAX = 999;
  var nav = document.querySelector('.rb-header__nav--bar');
  var drawer = document.getElementById('rb-mobile-drawer');
  var toggle = document.querySelector('.rb-mobile-menu-btn');
  var ignoreOutsideUntil = 0;

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function positionOpenMenus() {
    if (!nav) return;
    var bottom = nav.getBoundingClientRect().bottom + 8;
    /* Center within phone-stage body (not the wide window / grey rails) */
    var stage = document.body.getBoundingClientRect();
    var inset = 8;
    var left = Math.round(stage.left + inset);
    var width = Math.max(0, Math.round(stage.width - inset * 2));
    nav.querySelectorAll('.rb-header__dropdown.is-open .rb-header__menu').forEach(function (menu) {
      menu.style.top = bottom + 'px';
      menu.style.left = left + 'px';
      menu.style.right = 'auto';
      menu.style.width = width + 'px';
      menu.style.maxWidth = width + 'px';
      menu.style.transform = 'none';
      /* rb-nav-menu-fixed-viewport-v1 — a transformed ancestor becomes the containing block
         for position:fixed, so the viewport coords above land offset by that ancestor's
         position. Measure where the menu actually went and take the difference back out. */
      var rect = menu.getBoundingClientRect();
      var dy = rect.top - bottom;
      var dx = rect.left - left;
      if (Math.abs(dy) > 0.5) menu.style.top = bottom - dy + 'px';
      if (Math.abs(dx) > 0.5) menu.style.left = left - dx + 'px';
    });
    syncBackdropTop();
  }

  function clearMenuPosition(menu) {
    if (!menu) return;
    menu.style.top = '';
    menu.style.left = '';
    menu.style.right = '';
    menu.style.width = '';
    menu.style.maxWidth = '';
    menu.style.transform = '';
  }

  function ensureNavBackdrop() {
    var el = document.getElementById('rb-mobile-nav-backdrop');
    if (el) return el;
    /* div, not button ? avoids blue :active / focus rings on long-press */
    el = document.createElement('div');
    el.id = 'rb-mobile-nav-backdrop';
    el.className = 'rb-mobile-nav-backdrop';
    el.setAttribute('aria-label', 'Close menu');
    el.setAttribute('role', 'button');
    el.tabIndex = -1;
    document.body.appendChild(el);

    function closeFromBackdrop(event) {
      if (Date.now() < ignoreOutsideUntil) return;
      event.preventDefault();
      event.stopPropagation();
      closeAll();
    }

    /* Close on first contact ? no hold / delayed click */
    el.addEventListener('pointerdown', closeFromBackdrop, { capture: true });
    el.addEventListener('touchstart', closeFromBackdrop, { capture: true, passive: false });
    el.addEventListener('click', closeFromBackdrop);
    return el;
  }

  function syncBackdropTop() {
    var el = document.getElementById('rb-mobile-nav-backdrop');
    if (!el || !nav) return;
    /* Cover only open space below the pill row, clipped to the phone stage */
    el.style.top = Math.ceil(nav.getBoundingClientRect().bottom) + 'px';
    var stage = document.body.getBoundingClientRect();
    el.style.left = Math.round(stage.left) + 'px';
    el.style.right = 'auto';
    el.style.width = Math.round(stage.width) + 'px';
  }

  function setNavBackdrop(open) {
    var el = ensureNavBackdrop();
    if (open) syncBackdropTop();
    el.classList.toggle('is-visible', !!open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function closeDropdowns(except) {
    if (!nav) return;
    nav.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
      if (dropdown === except) return;
      dropdown.classList.remove('is-open');
      var pill = dropdown.querySelector('.rb-header__pill');
      var menu = dropdown.querySelector('.rb-header__menu');
      if (pill) pill.setAttribute('aria-expanded', 'false');
      clearMenuPosition(menu);
    });
  }

  function closeAll() {
    closeDropdowns();
    document.body.classList.remove('rb-mobile-nav-open');
    setNavBackdrop(false);
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function canHoverOpen() {
    /* Mouse on phone-stage / resized desktop — not sticky touch :hover */
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function openDropdown(dropdown, mode) {
    var pill = dropdown.querySelector('.rb-header__pill');
    closeDropdowns(dropdown);
    dropdown.classList.add('is-open');
    if (pill) pill.setAttribute('aria-expanded', 'true');
    positionOpenMenus();
    if (mode === 'hover') {
      /* Hover: no scroll-lock / backdrop — pointerleave closes (rb-mobile-pill-hover-v1) */
      document.body.classList.remove('rb-mobile-nav-open');
      setNavBackdrop(false);
      return;
    }
    document.body.classList.add('rb-mobile-nav-open');
    ignoreOutsideUntil = Date.now() + 400;
    setNavBackdrop(true);
  }

  /* bfcache / interrupted close can leave the body scroll-locked with no menu open */
  function recoverNavScrollLock() {
    if (document.querySelector('.rb-header__dropdown.is-open')) return;
    if (!document.body.classList.contains('rb-mobile-nav-open')) return;
    closeAll();
  }

  window.addEventListener('pageshow', recoverNavScrollLock);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recoverNavScrollLock();
  });

  /* Pills, open panel, or anything in the nav bar = not "outside" */
  function isInsideNavUi(target) {
    if (!target || !target.closest) return false;
    if (target.closest('#rb-mobile-nav-backdrop')) return false;
    if (target.closest('.rb-header__nav--bar')) return true;
    if (target.closest('.rb-header__dropdown.is-open .rb-header__menu')) return true;
    return false;
  }

  if (!nav) return;

  var hoverCloseTimer = 0;
  function cancelHoverClose() {
    if (hoverCloseTimer) {
      window.clearTimeout(hoverCloseTimer);
      hoverCloseTimer = 0;
    }
  }
  function scheduleHoverClose() {
    cancelHoverClose();
    hoverCloseTimer = window.setTimeout(function () {
      hoverCloseTimer = 0;
      if (!isMobile() || !canHoverOpen()) return;
      closeAll();
    }, 160);
  }

  nav.querySelectorAll('.rb-header__dropdown').forEach(function (dropdown) {
    var pill = dropdown.querySelector('.rb-header__pill');
    var menu = dropdown.querySelector('.rb-header__menu');
    if (!pill) return;

    /* Capture phase so handlers work even if other scripts stop bubbling */
    pill.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      cancelHoverClose();

      var isOpen = dropdown.classList.contains('is-open');
      if (isOpen) {
        closeAll();
        pill.blur();
        return;
      }

      openDropdown(dropdown, 'click');
    }, true);

    function onHoverEnter(event) {
      if (!isMobile() || !canHoverOpen()) return;
      if (event && event.pointerType && event.pointerType !== 'mouse') return;
      cancelHoverClose();
      openDropdown(dropdown, 'hover');
    }
    function onHoverLeave(event) {
      if (!isMobile() || !canHoverOpen()) return;
      if (event && event.pointerType && event.pointerType !== 'mouse') return;
      scheduleHoverClose();
    }

    dropdown.addEventListener('pointerenter', onHoverEnter);
    dropdown.addEventListener('pointerleave', onHoverLeave);
    /* Fixed menu sits outside the pill box — bridge the gap for mouse */
    if (menu) {
      menu.addEventListener('pointerenter', onHoverEnter);
      menu.addEventListener('pointerleave', onHoverLeave);
    }
  });

  /* Prefetch collection/page on press so navigation feels snappier */
  function prefetchHref(href) {
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      href = url.pathname + url.search + url.hash;
    } catch (err) {
      return;
    }
    if (document.head.querySelector('link[data-rb-nav-prefetch][href="' + href + '"]')) return;
    var el = document.createElement('link');
    el.rel = 'prefetch';
    el.as = 'document';
    el.href = href;
    el.setAttribute('data-rb-nav-prefetch', '1');
    document.head.appendChild(el);
  }

  nav.querySelectorAll('.rb-header__menu a[href]').forEach(function (link) {
    var warm = function () {
      if (!isMobile()) return;
      prefetchHref(link.getAttribute('href'));
    };
    link.addEventListener('pointerdown', warm, { passive: true });
    link.addEventListener('touchstart', warm, { passive: true });
  });

  /* Close the instant contact starts outside the nav UI (no hold / blue flash) */
  function onOutsidePointer(event) {
    if (!isMobile() || !nav) return;
    if (!document.body.classList.contains('rb-mobile-nav-open')) return;
    if (Date.now() < ignoreOutsideUntil) return;
    if (isInsideNavUi(event.target)) return;
    event.preventDefault();
    closeAll();
  }

  document.addEventListener('pointerdown', onOutsidePointer, true);
  document.addEventListener('touchstart', onOutsidePointer, { capture: true, passive: false });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) {
      closeAll();
      return;
    }
    positionOpenMenus();
  });

  /* Only an open dropdown has anything to reposition, but positionOpenMenus() reads layout
     three times — the nav, the body, and the backdrop — before it looks at whether one is
     open. Unguarded on a scroll listener that made every scroll event on every mobile page
     force a synchronous layout, which is most of why scrolling felt rough on a phone.
     The open check comes first now, and the rAF collapses a burst of events into one
     measure per frame for the case where a menu genuinely is open. */
  var menuScrollRaf = 0;
  window.addEventListener('scroll', function () {
    if (menuScrollRaf || !nav || !isMobile()) return;
    if (!nav.querySelector('.rb-header__dropdown.is-open')) return;
    menuScrollRaf = window.requestAnimationFrame(function () {
      menuScrollRaf = 0;
      positionOpenMenus();
    });
  }, { passive: true });

  if (toggle) {
    toggle.setAttribute('aria-hidden', 'true');
    toggle.tabIndex = -1;
  }
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
  }
})();

/* Shared L/R arrows for mobile swipe rails (mouse users on ≤999) */
(function () {
  function cardStep(track, cardSelector) {
    if (!track) return 0;
    var card = track.querySelector(cardSelector || ":scope > *");
    if (!card) return Math.max(120, Math.round(track.clientWidth * 0.85));
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    if (!gap || isNaN(gap)) gap = 0;
    return Math.max(1, Math.round(card.getBoundingClientRect().width + gap));
  }

  function ensureControls(rail, scrollbarSelector) {
    if (!rail) return null;
    var existing = rail.querySelector("[data-rb-carousel-controls]");
    if (existing) return existing;

    var scrollbar = rail.querySelector(scrollbarSelector);
    if (!scrollbar || !scrollbar.parentNode) return null;

    var wrap = document.createElement("div");
    wrap.className = "rb-carousel-controls";
    wrap.setAttribute("data-rb-carousel-controls", "");

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "rb-carousel-arrow rb-carousel-arrow--prev";
    prev.setAttribute("data-rb-carousel-prev", "");
    prev.setAttribute("aria-label", "Previous");
    prev.innerHTML = '<i class="ri-arrow-left-s-line" aria-hidden="true"></i>';

    var next = document.createElement("button");
    next.type = "button";
    next.className = "rb-carousel-arrow rb-carousel-arrow--next";
    next.setAttribute("data-rb-carousel-next", "");
    next.setAttribute("aria-label", "Next");
    next.innerHTML = '<i class="ri-arrow-right-s-line" aria-hidden="true"></i>';

    scrollbar.parentNode.insertBefore(wrap, scrollbar);
    wrap.appendChild(prev);
    wrap.appendChild(scrollbar);
    wrap.appendChild(next);
    return wrap;
  }

  function syncDisabled(track, rail, options) {
    if (!track || !rail) return;
    var prevBtn = rail.querySelector("[data-rb-carousel-prev]");
    var nextBtn = rail.querySelector("[data-rb-carousel-next]");
    if (!prevBtn || !nextBtn) return;
    options = options || rail._rbCarouselArrowOpts || {};
    if (typeof options.getNavState === "function") {
      var st = options.getNavState(track) || {};
      prevBtn.disabled = !!st.atStart;
      nextBtn.disabled = !!st.atEnd;
      return;
    }
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var left = track.scrollLeft;
    prevBtn.disabled = left <= 2;
    nextBtn.disabled = left >= maxScroll - 2 || maxScroll <= 2;
  }

  function bind(track, rail, options) {
    options = options || {};
    if (!track || !rail) return;
    rail._rbCarouselArrowOpts = options;
    if (rail.dataset.rbCarouselArrowsBound === "1") {
      syncDisabled(track, rail, options);
      return;
    }

    var scrollbarSelector = options.scrollbarSelector ||
      ".rb-featured__scrollbar, .rb-perks__scrollbar, .rb-hero__scrollbar, .rb-rewards__tiers-scrollbar, .rb-rewards__earn-scrollbar, .rb-rewards__redeem-scrollbar, .rb-profile__scrollbar, [data-rb-rewards-tiers-scrollbar], [data-rb-rewards-earn-scrollbar], [data-rb-rewards-redeem-scrollbar], [data-rb-profile-scrollbar]";
    var wrap = ensureControls(rail, scrollbarSelector);
    if (!wrap) return;

    var prevBtn = wrap.querySelector("[data-rb-carousel-prev]");
    var nextBtn = wrap.querySelector("[data-rb-carousel-next]");
    var selector = options.cardSelector || ":scope > *";
    var behavior = options.behavior || "smooth";

    function step(dir) {
      if (typeof options.navigate === "function") {
        options.navigate(dir, track);
      } else {
        var amount = typeof options.step === "function"
          ? options.step(track)
          : cardStep(track, selector);
        if (!amount) return;
        track.scrollBy({ left: dir * amount, behavior: behavior });
      }
      window.setTimeout(function () {
        syncDisabled(track, rail, options);
      }, 80);
    }

    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      step(-1);
    });
    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      step(1);
    });

    rail.dataset.rbCarouselArrowsBound = "1";
    syncDisabled(track, rail, options);
  }

  window.rbMobileCarouselArrows = {
    bind: bind,
    sync: function (track, rail) {
      syncDisabled(track, rail, rail && rail._rbCarouselArrowOpts);
    },
    cardStep: cardStep
  };
})();

/* Favorites ? per-group mobile swipe rails (Swipe > + scrollbar under each brand) */
(function () {
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var NUDGE_KEY = "rbFeaturedNudgeDone";

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getRailEls(track) {
    if (!track) return null;
    var group = track.closest(".rb-featured__group") || track.closest(".rb-ymal") || track.closest("[data-rb-card-carousel]");
    if (!group) return null;
    var rail = group.querySelector("[data-rb-featured-rail]");
    if (!rail) return null;
    return {
      rail: rail,
      bar: rail.querySelector("[data-rb-featured-bar]"),
      thumb: rail.querySelector("[data-rb-featured-thumb]"),
    };
  }

  function getTracks(section) {
    return section ? Array.prototype.slice.call(section.querySelectorAll("[data-rb-featured-track]")) : [];
  }

  function getCarouselSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = [];
    scope.querySelectorAll(".rb-featured, .rb-ymal[data-rb-card-carousel], [data-rb-card-carousel]").forEach(function (el) {
      list.push(el);
    });
    if (root && root.classList && (root.classList.contains("rb-featured") || root.classList.contains("rb-ymal") || root.hasAttribute("data-rb-card-carousel"))) {
      list.push(root);
    }
    return list;
  }

  function trackOverflows(track) {
    return !!(track && track.scrollWidth - track.clientWidth > 8);
  }

  function syncThumb(track, options) {
    var ui = getRailEls(track);
    if (!ui || !ui.bar || !ui.thumb) return;

    var cardCount = track ? track.querySelectorAll(":scope > .rb-product").length : 0;
    var hasSwipe = isMobile() && (trackOverflows(track) || cardCount > 1);

    if (!hasSwipe) {
      ui.rail.setAttribute("hidden", "");
      return;
    }

    ui.rail.removeAttribute("hidden");
    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(track, ui.rail, {
        scrollbarSelector: "[data-rb-featured-scrollbar]",
        cardSelector: ":scope > .rb-product"
      });
      window.rbMobileCarouselArrows.sync(track, ui.rail);
    }

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var barWidth = ui.bar.clientWidth || track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (track.clientWidth / Math.max(track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);
    var state = track._rbThumbSmooth || (track._rbThumbSmooth = { x: targetX, target: targetX, raf: 0, width: 0 });

    if (state.width !== thumbWidth) {
      state.width = thumbWidth;
      ui.thumb.style.width = thumbWidth + "px";
    }

    state.target = targetX;
    if (snap) {
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = 0;
      }
      state.x = targetX;
      ui.thumb.style.transform = "translate3d(" + targetX + "px, 0, 0)";
      return;
    }

    if (state.raf) return;
    state.raf = window.requestAnimationFrame(function tick() {
      var delta = state.target - state.x;
      if (Math.abs(delta) < 0.2) {
        state.x = state.target;
        state.raf = 0;
      } else {
        state.x += delta * 0.45;
        state.raf = window.requestAnimationFrame(tick);
      }
      ui.thumb.style.transform = "translate3d(" + state.x + "px, 0, 0)";
    });
  }

  function syncActiveCard(track) {
    if (!track) return;
    var cards = track.querySelectorAll(".rb-product");
    if (!cards.length) return;

    if (!isMobile()) {
      cards.forEach(function (card) {
        card.classList.remove("is-carousel-active");
      });
      return;
    }

    var trackRect = track.getBoundingClientRect();
    var focusX = trackRect.left + trackRect.width * 0.5;
    var best = null;
    var bestDist = Infinity;

    cards.forEach(function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      var center = rect.left + rect.width * 0.5;
      var dist = Math.abs(center - focusX);
      if (dist < bestDist) {
        bestDist = dist;
        best = card;
      }
    });

    /* Exclusive: clear every card first, then mark only the centered one */
    cards.forEach(function (card) {
      card.classList.remove("is-carousel-active");
    });
    if (best) best.classList.add("is-carousel-active");
  }

  function syncSection(section) {
    getTracks(section).forEach(function (track) {
      syncThumb(track, { snap: true });
      syncActiveCard(track);
    });
  }

  function nudge(track) {
    if (prefersReducedMotion()) return;
    if (sessionStorage.getItem(NUDGE_KEY) === "1") return;
    if (!trackOverflows(track)) return;

    sessionStorage.setItem(NUDGE_KEY, "1");
    var peek = Math.min(36, Math.round(track.clientWidth * 0.08));
    track.scrollTo({ left: peek, behavior: "smooth" });
    window.setTimeout(function () {
      track.scrollTo({ left: 0, behavior: "smooth" });
    }, 420);
  }

  function equalizeTrackHeights(track) {
    if (!track || !isMobile()) return;
    var cards = track.querySelectorAll(":scope > .rb-product");
    if (!cards.length) return;

    var maxH = 0;
    cards.forEach(function (card) {
      card.style.minHeight = "";
    });
    cards.forEach(function (card) {
      maxH = Math.max(maxH, Math.ceil(card.getBoundingClientRect().height));
    });
    if (maxH < 1) return;
    cards.forEach(function (card) {
      card.style.minHeight = maxH + "px";
    });
  }

  function equalizeSectionHeights(section) {
    getTracks(section).forEach(equalizeTrackHeights);
  }

  function bindSection(section) {
    if (!section || section.dataset.rbFeaturedBound === "1") return;

    var tracks = getTracks(section);
    if (!tracks.length) return;
    section.dataset.rbFeaturedBound = "1";

    tracks.forEach(function (track) {
      var ui = getRailEls(track);
      if (ui && window.rbMobileCarouselArrows) {
        window.rbMobileCarouselArrows.bind(track, ui.rail, {
          scrollbarSelector: "[data-rb-featured-scrollbar]",
          cardSelector: ":scope > .rb-product"
        });
      }

      var scrollRaf = 0;
      function onScrollFrame() {
        scrollRaf = 0;
        syncThumb(track);
        syncActiveCard(track);
      }
      track.addEventListener("scroll", function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(onScrollFrame);
      }, { passive: true });
      track.addEventListener("scrollend", function () {
        syncThumb(track, { snap: true });
        syncActiveCard(track);
      }, { passive: true });
      syncActiveCard(track);

      /* Re-measure when images/Yotpo change card size ? faster than fixed long timeouts */
      if (typeof ResizeObserver !== "undefined" && !track._rbRailRo) {
        var roRaf = 0;
        track._rbRailRo = new ResizeObserver(function () {
          if (roRaf) return;
          roRaf = window.requestAnimationFrame(function () {
            roRaf = 0;
            equalizeTrackHeights(track);
            syncThumb(track, { snap: true });
            syncActiveCard(track);
          });
        });
        track._rbRailRo.observe(track);
      }
    });

    function refresh() {
      equalizeSectionHeights(section);
      syncSection(section);
    }

    refresh();
    /* Double rAF: first paint after layout, second after paint settle */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refresh);
    });
    window.setTimeout(refresh, 120);
    window.setTimeout(refresh, 500);

    if (typeof IntersectionObserver !== "undefined") {
      var seen = false;
      var firstTrack = tracks[0];
      var observeTarget = section.querySelector("[data-rb-featured-groups]") || section;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen || !isMobile() || !firstTrack) return;
          seen = true;
          window.setTimeout(function () {
            nudge(firstTrack);
            refresh();
          }, 200);
          io.disconnect();
        });
      }, { threshold: 0.2 });
      io.observe(observeTarget);
    }
  }

  function initAll(root) {
    getCarouselSections(root || document).forEach(bindSection);
  }

  function onResize() {
    getCarouselSections(document).forEach(function (section) {
      syncSection(section);
      equalizeSectionHeights(section);
    });
  }

  window.rbInitProductCardCarousels = function (root) {
    var scope = root || document;
    getCarouselSections(scope).forEach(function (section) {
      section.dataset.rbFeaturedBound = "0";
      bindSection(section);
    });
  };

  window.rbSyncProductCardCarousels = function (root) {
    getCarouselSections(root || document).forEach(function (section) {
      equalizeSectionHeights(section);
      syncSection(section);
    });
  };

  function boot() {
    initAll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  /* Light re-sync after images ? do not rebind */
  window.addEventListener("load", function () {
    window.rbSyncProductCardCarousels();
  });
  window.addEventListener("resize", onResize);
  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    var section = null;
    if (target && target.querySelector) {
      section = target.querySelector(".rb-featured, .rb-ymal[data-rb-card-carousel], [data-rb-card-carousel]");
      if (!section && target.classList && (target.classList.contains("rb-featured") || target.classList.contains("rb-ymal") || target.hasAttribute("data-rb-card-carousel"))) {
        section = target;
      }
    }
    if (section) {
      section.dataset.rbFeaturedBound = "0";
      bindSection(section);
      return;
    }
    initAll();
  });
})();

/* Perks ? mobile horizontal snap + top swipe rail */
(function () {
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var NUDGE_KEY = "rbPerksNudgeDone";

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getSectionEls(section) {
    if (!section) return null;
    var track = section.querySelector("[data-rb-perks-track]");
    var rail = section.querySelector("[data-rb-perks-rail]");
    if (!track || !rail) return null;
    return {
      track: track,
      rail: rail,
      bar: rail.querySelector("[data-rb-perks-bar]"),
      thumb: rail.querySelector("[data-rb-perks-thumb]"),
    };
  }

  function trackOverflows(track) {
    return !!(track && track.scrollWidth - track.clientWidth > 8);
  }

  function syncThumb(ui, options) {
    if (!ui || !ui.bar || !ui.thumb) return;

    if (!isMobile() || !trackOverflows(ui.track)) {
      ui.rail.setAttribute("hidden", "");
      return;
    }

    ui.rail.removeAttribute("hidden");
    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(ui.track, ui.rail, {
        scrollbarSelector: "[data-rb-perks-scrollbar]",
        cardSelector: ":scope > .rb-perk-row"
      });
      window.rbMobileCarouselArrows.sync(ui.track, ui.rail);
    }

    var maxScroll = Math.max(0, ui.track.scrollWidth - ui.track.clientWidth);
    var barWidth = ui.bar.clientWidth || ui.track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (ui.track.clientWidth / Math.max(ui.track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? ui.track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);
    var state = ui.track._rbThumbSmooth || (ui.track._rbThumbSmooth = { x: targetX, target: targetX, raf: 0, width: 0 });

    if (state.width !== thumbWidth) {
      state.width = thumbWidth;
      ui.thumb.style.width = thumbWidth + "px";
    }

    state.target = targetX;
    if (snap) {
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = 0;
      }
      state.x = targetX;
      ui.thumb.style.transform = "translate3d(" + targetX + "px, 0, 0)";
      return;
    }

    if (state.raf) return;
    state.raf = window.requestAnimationFrame(function tick() {
      var delta = state.target - state.x;
      if (Math.abs(delta) < 0.2) {
        state.x = state.target;
        state.raf = 0;
      } else {
        state.x += delta * 0.45;
        state.raf = window.requestAnimationFrame(tick);
      }
      ui.thumb.style.transform = "translate3d(" + state.x + "px, 0, 0)";
    });
  }

  function equalizeHeights(track) {
    if (!track || !isMobile()) return;
    var cards = track.querySelectorAll(":scope > .rb-perk-row");
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = "";
    });
    var maxH = 0;
    cards.forEach(function (card) {
      maxH = Math.max(maxH, Math.ceil(card.getBoundingClientRect().height));
    });
    if (maxH < 1) return;
    cards.forEach(function (card) {
      card.style.minHeight = maxH + "px";
    });
  }

  function nudge(track) {
    if (prefersReducedMotion()) return;
    if (sessionStorage.getItem(NUDGE_KEY) === "1") return;
    if (!trackOverflows(track)) return;

    sessionStorage.setItem(NUDGE_KEY, "1");
    var peek = Math.min(36, Math.round(track.clientWidth * 0.08));
    track.scrollTo({ left: peek, behavior: "smooth" });
    window.setTimeout(function () {
      track.scrollTo({ left: 0, behavior: "smooth" });
    }, 420);
  }

  function bindSection(section) {
    if (!section || section.dataset.rbPerksBound === "1") return;
    var ui = getSectionEls(section);
    if (!ui) return;
    section.dataset.rbPerksBound = "1";

    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(ui.track, ui.rail, {
        scrollbarSelector: "[data-rb-perks-scrollbar]",
        cardSelector: ":scope > .rb-perk-row"
      });
    }

    var scrollRaf = 0;
    function onScrollFrame() {
      scrollRaf = 0;
      syncThumb(ui);
    }
    ui.track.addEventListener("scroll", function () {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(onScrollFrame);
    }, { passive: true });
    ui.track.addEventListener("scrollend", function () {
      syncThumb(ui, { snap: true });
    }, { passive: true });

    function refresh() {
      equalizeHeights(ui.track);
      syncThumb(ui, { snap: true });
    }

    refresh();
    window.setTimeout(refresh, 400);
    window.setTimeout(refresh, 1200);

    if (typeof IntersectionObserver !== "undefined") {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen || !isMobile()) return;
          seen = true;
          window.setTimeout(function () {
            nudge(ui.track);
            refresh();
          }, 350);
          io.disconnect();
        });
      }, { threshold: 0.3 });
      io.observe(section);
    }
  }

  function initAll() {
    document.querySelectorAll(".rb-perks").forEach(bindSection);
  }

  function onResize() {
    document.querySelectorAll(".rb-perks").forEach(function (section) {
      var ui = getSectionEls(section);
      if (!ui) return;
      equalizeHeights(ui.track);
      syncThumb(ui, { snap: true });
    });
  }

  initAll();
  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll);
  window.addEventListener("resize", onResize);
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector(".rb-perks") || (event.target.classList && event.target.classList.contains("rb-perks") ? event.target : null)
      : null;
    if (section) {
      section.dataset.rbPerksBound = "0";
      bindSection(section);
      return;
    }
    initAll();
  });
})();

/* Hero slider — L/R arrows on mobile swipe rail */
(function () {
  var MOBILE_MAX = 999;

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function bindHero() {
    if (!window.rbMobileCarouselArrows) return;
    var carousel = document.querySelector("[data-hero-carousel]");
    if (!carousel) return;
    var track = carousel.querySelector("[data-hero-track]");
    var rail = carousel.querySelector("[data-rb-hero-rail]");
    if (!track || !rail) return;

    window.rbMobileCarouselArrows.bind(track, rail, {
      scrollbarSelector: ".rb-hero__scrollbar",
      step: function (t) {
        return Math.max(1, Math.round(t.clientWidth));
      }
    });
    window.rbMobileCarouselArrows.sync(track, rail);

    if (track.dataset.rbHeroArrowScrollBound === "1") return;
    track.dataset.rbHeroArrowScrollBound = "1";
    track.addEventListener("scroll", function () {
      if (!isMobile()) return;
      window.rbMobileCarouselArrows.sync(track, rail);
    }, { passive: true });
  }

  function boot() {
    bindHero();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.addEventListener("load", bindHero);
  window.addEventListener("resize", bindHero);
  document.addEventListener("shopify:section:load", bindHero);
})();

/* Loyalty tiers — mobile 5-card swipe (REWARDS + 4 tiers) + Swipe tracker */
(function () {
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var NUDGE_KEY = "rbRewardsTiersNudgeDone";

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getRoot() {
    return document.querySelector(".rb-rewards .rewmob");
  }

  function getEls(root) {
    if (!root) return null;
    var track = root.querySelector("[data-rb-rewards-tiers-track]");
    var rail = root.querySelector("[data-rb-rewards-tiers-rail]");
    if (!track || !rail) return null;
    return {
      track: track,
      rail: rail,
      bar: rail.querySelector("[data-rb-rewards-tiers-bar]"),
      thumb: rail.querySelector("[data-rb-rewards-tiers-thumb]"),
    };
  }

  function trackOverflows(track) {
    return !!(track && track.scrollWidth - track.clientWidth > 8);
  }

  function syncThumb(ui, options) {
    if (!ui || !ui.bar || !ui.thumb) return;

    if (!isMobile() || !trackOverflows(ui.track)) {
      ui.rail.setAttribute("hidden", "");
      return;
    }

    ui.rail.removeAttribute("hidden");

    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(ui.track, ui.rail, {
        scrollbarSelector: "[data-rb-rewards-tiers-scrollbar], .rb-rewards__tiers-scrollbar",
        cardSelector: ":scope > .re4it"
      });
      window.rbMobileCarouselArrows.sync(ui.track, ui.rail);
    }

    var maxScroll = Math.max(0, ui.track.scrollWidth - ui.track.clientWidth);
    var barWidth = ui.bar.clientWidth || ui.track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (ui.track.clientWidth / Math.max(ui.track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? ui.track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);
    var state = ui.track._rbThumbSmooth || (ui.track._rbThumbSmooth = { x: targetX, target: targetX, raf: 0, width: 0 });

    if (state.width !== thumbWidth) {
      state.width = thumbWidth;
      ui.thumb.style.width = thumbWidth + "px";
    }

    state.target = targetX;
    if (snap) {
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = 0;
      }
      state.x = targetX;
      ui.thumb.style.transform = "translate3d(" + targetX + "px, 0, 0)";
      return;
    }

    if (state.raf) return;
    state.raf = window.requestAnimationFrame(function tick() {
      var delta = state.target - state.x;
      if (Math.abs(delta) < 0.2) {
        state.x = state.target;
        state.raf = 0;
      } else {
        state.x += delta * 0.45;
        state.raf = window.requestAnimationFrame(tick);
      }
      ui.thumb.style.transform = "translate3d(" + state.x + "px, 0, 0)";
    });
  }

  function equalizeHeights(track) {
    if (!track || !isMobile()) return;
    var cards = track.querySelectorAll(":scope > .re4it");
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = "";
    });
    var maxH = 0;
    cards.forEach(function (card) {
      maxH = Math.max(maxH, Math.ceil(card.getBoundingClientRect().height));
    });
    if (maxH < 1) return;
    cards.forEach(function (card) {
      card.style.minHeight = maxH + "px";
    });
  }

  function nudge(track) {
    if (prefersReducedMotion()) return;
    if (sessionStorage.getItem(NUDGE_KEY) === "1") return;
    if (!trackOverflows(track)) return;

    sessionStorage.setItem(NUDGE_KEY, "1");
    var peek = Math.min(36, Math.round(track.clientWidth * 0.08));
    track.scrollTo({ left: peek, behavior: "smooth" });
    window.setTimeout(function () {
      track.scrollTo({ left: 0, behavior: "smooth" });
    }, 420);
  }

  function bind() {
    var root = getRoot();
    if (!root || root.dataset.rbRewardsTiersBound === "1") return;
    var ui = getEls(root);
    if (!ui) return;
    root.dataset.rbRewardsTiersBound = "1";

    var scrollRaf = 0;
    ui.track.addEventListener("scroll", function () {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        syncThumb(ui);
      });
    }, { passive: true });
    ui.track.addEventListener("scrollend", function () {
      syncThumb(ui, { snap: true });
    }, { passive: true });

    function refresh() {
      equalizeHeights(ui.track);
      syncThumb(ui, { snap: true });
    }

    refresh();
    window.setTimeout(refresh, 400);
    window.setTimeout(refresh, 1200);

    if (typeof IntersectionObserver !== "undefined") {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen || !isMobile()) return;
          seen = true;
          window.setTimeout(function () {
            nudge(ui.track);
            refresh();
          }, 350);
          io.disconnect();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    }
  }

  function onResize() {
    var root = getRoot();
    var ui = getEls(root);
    if (!ui) return;
    if (!isMobile()) {
      ui.rail.setAttribute("hidden", "");
      return;
    }
    equalizeHeights(ui.track);
    syncThumb(ui, { snap: true });
  }

  bind();
  document.addEventListener("DOMContentLoaded", bind);
  window.addEventListener("load", bind);
  window.addEventListener("resize", onResize);
})();

/* Loyalty Ways to Earn — mobile swipe cards + Swipe tracker (same pattern as tiers) */
(function () {
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var NUDGE_KEY = "rbRewardsEarnNudgeDone";

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getCampaign() {
    return document.querySelector(".rb-rewards .yotpo-widget-campaign-widget");
  }

  function markTrack(track) {
    track.classList.add("rb-rewards__earn-track");
    track.setAttribute("data-rb-rewards-earn-track", "");
    track.setAttribute("tabindex", "0");
    if (!track.getAttribute("role")) track.setAttribute("role", "region");
    if (!track.getAttribute("aria-label")) {
      track.setAttribute("aria-label", "Ways to earn. Swipe sideways for more.");
    }
  }

  function collectOuterTiles(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        ":scope > .yotpo-outer-tile, :scope > .flexified-child, :scope > .yotpo-tile-wrapper"
      )
    );
  }

  function ensureSwipe(campaign) {
    if (!campaign || !isMobile()) return null;
    var container = campaign.querySelector(".yotpo-widget-campaign-widget-container");
    if (!container) return null;

    var track = container.querySelector("[data-rb-rewards-earn-track]");
    if (!track) {
      /* Yotpo ships tiles in .flexified-wrapper — reuse it as the swipe track */
      var flex = container.querySelector(":scope > .flexified-wrapper, .flexified-wrapper");
      if (flex) {
        track = flex;
        markTrack(track);
        collectOuterTiles(track).forEach(function (tile) {
          tile.classList.add("rb-rewards__earn-card");
        });
      } else {
        var tiles = collectOuterTiles(container);
        if (!tiles.length) return null;

        track = document.createElement("div");
        markTrack(track);
        tiles.forEach(function (tile) {
          tile.classList.add("rb-rewards__earn-card");
          track.appendChild(tile);
        });
        container.appendChild(track);
      }
    } else {
      markTrack(track);
      collectOuterTiles(track).forEach(function (tile) {
        tile.classList.add("rb-rewards__earn-card");
      });
    }

    var rail = campaign.querySelector("[data-rb-rewards-earn-rail]");
    if (!rail) {
      rail = document.createElement("div");
      rail.className = "rb-rewards__earn-rail rb-mobile-only";
      rail.setAttribute("data-rb-rewards-earn-rail", "");
      rail.innerHTML =
        '<p class="rb-rewards__earn-swipe-hint" data-rb-rewards-earn-hint aria-hidden="true">Swipe <i class="ri-arrow-right-line rb-rewards__earn-swipe-chevron" aria-hidden="true"></i></p>' +
        '<div class="rb-rewards__earn-scrollbar" data-rb-rewards-earn-scrollbar>' +
        '<div class="rb-rewards__earn-scrollbar-track" data-rb-rewards-earn-bar>' +
        '<div class="rb-rewards__earn-scrollbar-thumb" data-rb-rewards-earn-thumb></div>' +
        "</div></div>";
      /* Rail sits under the Ways to Earn headline, above the card track */
      track.parentNode.insertBefore(rail, track);
    }

    return {
      campaign: campaign,
      track: track,
      rail: rail,
      bar: rail.querySelector("[data-rb-rewards-earn-bar]"),
      thumb: rail.querySelector("[data-rb-rewards-earn-thumb]"),
    };
  }

  function trackOverflows(track) {
    return !!(track && track.scrollWidth - track.clientWidth > 8);
  }

  function syncThumb(ui, options) {
    if (!ui || !ui.bar || !ui.thumb) return;

    if (!isMobile() || !trackOverflows(ui.track)) {
      ui.rail.setAttribute("hidden", "");
      return;
    }

    ui.rail.removeAttribute("hidden");

    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(ui.track, ui.rail, {
        scrollbarSelector: "[data-rb-rewards-earn-scrollbar], .rb-rewards__earn-scrollbar",
        cardSelector: ":scope > .rb-rewards__earn-card, :scope > .yotpo-outer-tile, :scope > .flexified-child"
      });
      window.rbMobileCarouselArrows.sync(ui.track, ui.rail);
    }

    var maxScroll = Math.max(0, ui.track.scrollWidth - ui.track.clientWidth);
    var barWidth = ui.bar.clientWidth || ui.track.clientWidth;
    var thumbWidth = Math.max(
      THUMB_MIN,
      Math.round(barWidth * (ui.track.clientWidth / Math.max(ui.track.scrollWidth, 1)))
    );
    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var progress = maxScroll > 0 ? ui.track.scrollLeft / maxScroll : 0;
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);
    var state = ui.track._rbThumbSmooth || (ui.track._rbThumbSmooth = { x: targetX, target: targetX, raf: 0, width: 0 });

    if (state.width !== thumbWidth) {
      state.width = thumbWidth;
      ui.thumb.style.width = thumbWidth + "px";
    }

    state.target = targetX;
    if (snap) {
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = 0;
      }
      state.x = targetX;
      ui.thumb.style.transform = "translate3d(" + targetX + "px, 0, 0)";
      return;
    }

    if (state.raf) return;
    state.raf = window.requestAnimationFrame(function tick() {
      var delta = state.target - state.x;
      if (Math.abs(delta) < 0.2) {
        state.x = state.target;
        state.raf = 0;
      } else {
        state.x += delta * 0.45;
        state.raf = window.requestAnimationFrame(tick);
      }
      ui.thumb.style.transform = "translate3d(" + state.x + "px, 0, 0)";
    });
  }

  function equalizeHeights(track) {
    if (!track || !isMobile()) return;
    var cards = track.querySelectorAll(
      ":scope > .yotpo-outer-tile, :scope > .flexified-child, :scope > .yotpo-tile-wrapper, :scope > .rb-rewards__earn-card"
    );
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = "";
    });
    var maxH = 0;
    cards.forEach(function (card) {
      maxH = Math.max(maxH, Math.ceil(card.getBoundingClientRect().height));
    });
    if (maxH < 1) return;
    cards.forEach(function (card) {
      card.style.minHeight = maxH + "px";
    });
  }

  function nudge(track) {
    if (prefersReducedMotion()) return;
    if (sessionStorage.getItem(NUDGE_KEY) === "1") return;
    if (!trackOverflows(track)) return;

    sessionStorage.setItem(NUDGE_KEY, "1");
    var peek = Math.min(36, Math.round(track.clientWidth * 0.08));
    track.scrollTo({ left: peek, behavior: "smooth" });
    window.setTimeout(function () {
      track.scrollTo({ left: 0, behavior: "smooth" });
    }, 420);
  }

  function bind() {
    if (!isMobile()) return;
    var campaign = getCampaign();
    if (!campaign) return;
    var ui = ensureSwipe(campaign);
    if (!ui) return;

    if (campaign.dataset.rbRewardsEarnBound === "1") {
      equalizeHeights(ui.track);
      syncThumb(ui, { snap: true });
      return;
    }
    campaign.dataset.rbRewardsEarnBound = "1";

    var scrollRaf = 0;
    ui.track.addEventListener(
      "scroll",
      function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          syncThumb(ui);
        });
      },
      { passive: true }
    );
    ui.track.addEventListener(
      "scrollend",
      function () {
        syncThumb(ui, { snap: true });
      },
      { passive: true }
    );

    function refresh() {
      if (!isMobile()) return;
      var next = ensureSwipe(campaign);
      if (!next) return;
      equalizeHeights(next.track);
      syncThumb(next, { snap: true });
    }

    refresh();
    window.setTimeout(refresh, 400);
    window.setTimeout(refresh, 1200);
    window.setTimeout(refresh, 2500);

    if (typeof MutationObserver !== "undefined") {
      var mo = new MutationObserver(function () {
        if (campaign.dataset.rbRewardsEarnBound === "1" && campaign.querySelector("[data-rb-rewards-earn-track]")) {
          refresh();
          return;
        }
        campaign.dataset.rbRewardsEarnBound = "0";
        bind();
      });
      mo.observe(campaign, { childList: true, subtree: true });
    }

    if (typeof IntersectionObserver !== "undefined") {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen || !isMobile()) return;
          seen = true;
          window.setTimeout(function () {
            nudge(ui.track);
            refresh();
          }, 350);
          io.disconnect();
        });
      }, { threshold: 0.2 });
      io.observe(campaign);
    }
  }

  function onResize() {
    var campaign = getCampaign();
    if (!campaign) return;
    if (!isMobile()) {
      var rail = campaign.querySelector("[data-rb-rewards-earn-rail]");
      if (rail) rail.setAttribute("hidden", "");
      return;
    }
    campaign.dataset.rbRewardsEarnBound = "0";
    bind();
  }

  bind();
  document.addEventListener("DOMContentLoaded", bind);
  window.addEventListener("load", bind);
  window.addEventListener("resize", onResize);
  window.setTimeout(bind, 800);
  window.setTimeout(bind, 2000);
  window.setTimeout(bind, 4000);
})();

/* Loyalty Discounts — mobile swipe cards + Swipe tracker */
(function () {
  var MOBILE_MAX = 999;
  var THUMB_MIN = 48;
  var NUDGE_KEY = "rbRewardsRedeemNudgeDone";

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function getWidget() {
    return document.querySelector(".rb-rewards .yotpo-coupons-redemption-widget");
  }

  function getCards(track) {
    if (!track) return [];
    var slides = track.querySelectorAll(".yotpo-redemption-slide-item");
    if (slides.length) return Array.prototype.slice.call(slides);

    var direct = [];
    for (var i = 0; i < track.children.length; i++) {
      var el = track.children[i];
      if (el.nodeType === 1 && el.classList && el.classList.contains("yotpo-redemption-item")) {
        direct.push(el);
      }
    }
    if (direct.length) return direct;
    return Array.prototype.slice.call(track.querySelectorAll(".yotpo-redemption-item"));
  }

  function getSwiper(widget) {
    if (!widget) return null;
    var host =
      widget.querySelector(".yotpo-redemption-options-carousel.swiper-container") ||
      widget.querySelector(".yotpo-redemption-options-carousel") ||
      widget.querySelector(".swiper-container");
    return host && host.swiper ? host.swiper : null;
  }

  function tierFromRewardText(text) {
    if (/\$?\s*20(?:[.,]0+)?\b/i.test(text) || /\b20\s*(?:\$|off)/i.test(text)) return "chill";
    if (/\$?\s*40(?:[.,]0+)?\b/i.test(text) || /\b40\s*(?:\$|off)/i.test(text)) return "serenity";
    if (/\$?\s*60(?:[.,]0+)?\b/i.test(text) || /\b60\s*(?:\$|off)/i.test(text)) return "titans";
    return "";
  }

  function tagTier(track) {
    var cards = getCards(track);
    var fallback = ["chill", "serenity", "titans"];
    for (var i = 0; i < cards.length; i++) {
      var item = cards[i];
      var reward = item.querySelector(".yotpo-redemption-option-reward");
      if (!reward) continue;
      var text = (reward.textContent || "").replace(/\s+/g, " ").trim();
      if (!text) continue;
      var tier = tierFromRewardText(text) || fallback[i] || "";
      item.classList.remove("rb-redeem-tier--chill", "rb-redeem-tier--serenity", "rb-redeem-tier--titans");
      reward.classList.remove(
        "rb-redeem-reward-tier--chill",
        "rb-redeem-reward-tier--serenity",
        "rb-redeem-reward-tier--titans"
      );
      if (!tier) continue;
      item.classList.add("rb-redeem-tier--" + tier);
      reward.classList.add("rb-redeem-reward-tier--" + tier);
      reward.setAttribute("data-rb-label", text);
      reward.style.setProperty("color", "transparent", "important");
      reward.style.setProperty("-webkit-text-fill-color", "transparent", "important");
      reward.style.setProperty("background-image", "none", "important");
      reward.style.setProperty("background", "none", "important");
    }
  }

  function markTrack(track) {
    track.classList.add("rb-rewards__redeem-track");
    track.setAttribute("data-rb-rewards-redeem-track", "");
    track.setAttribute("tabindex", "0");
    if (!track.getAttribute("role")) track.setAttribute("role", "region");
    if (!track.getAttribute("aria-label")) {
      track.setAttribute("aria-label", "Loyalty discounts. Swipe sideways for more.");
    }
  }

  function ensureSwipe(widget) {
    if (!widget || !isMobile()) return null;
    var track = widget.querySelector(".yotpo-redemption-options-list");
    if (!track) return null;

    markTrack(track);
    var cards = getCards(track);
    cards.forEach(function (card) {
      card.classList.add("rb-rewards__redeem-card");
    });
    tagTier(track);

    var rail = widget.querySelector("[data-rb-rewards-redeem-rail]");
    if (!rail) {
      rail = document.createElement("div");
      rail.className = "rb-rewards__redeem-rail";
      rail.setAttribute("data-rb-rewards-redeem-rail", "");
      rail.innerHTML =
        '<p class="rb-rewards__redeem-swipe-hint" data-rb-rewards-redeem-hint aria-hidden="true">Swipe <i class="ri-arrow-right-line rb-rewards__redeem-swipe-chevron" aria-hidden="true"></i></p>' +
        '<div class="rb-rewards__redeem-scrollbar" data-rb-rewards-redeem-scrollbar>' +
        '<div class="rb-rewards__redeem-scrollbar-track" data-rb-rewards-redeem-bar>' +
        '<div class="rb-rewards__redeem-scrollbar-thumb" data-rb-rewards-redeem-thumb></div>' +
        "</div></div>";
      /* Place tracker under the cards (same visual spot users expect) */
      if (track.parentNode) {
        if (track.nextSibling) track.parentNode.insertBefore(rail, track.nextSibling);
        else track.parentNode.appendChild(rail);
      }
    }

    /* Always show when we have discount cards — never leave hidden stuck on */
    if (cards.length > 1) rail.removeAttribute("hidden");
    else rail.setAttribute("hidden", "");

    return {
      widget: widget,
      track: track,
      rail: rail,
      bar: rail.querySelector("[data-rb-rewards-redeem-bar]"),
      thumb: rail.querySelector("[data-rb-rewards-redeem-thumb]"),
      cards: cards,
    };
  }

  function trackOverflows(track) {
    return !!(track && track.scrollWidth - track.clientWidth > 8);
  }

  function syncThumb(ui, options) {
    if (!ui || !ui.bar || !ui.thumb || !ui.rail) return;

    if (!isMobile() || (ui.cards && ui.cards.length < 2) || getCards(ui.track).length < 2) {
      ui.rail.setAttribute("hidden", "");
      return;
    }

    ui.rail.removeAttribute("hidden");
    ui.rail.style.setProperty("display", "flex", "important");

    if (window.rbMobileCarouselArrows) {
      window.rbMobileCarouselArrows.bind(ui.track, ui.rail, {
        scrollbarSelector: "[data-rb-rewards-redeem-scrollbar], .rb-rewards__redeem-scrollbar",
        cardSelector: ":scope > .rb-rewards__redeem-card, :scope > .yotpo-redemption-slide-item, :scope > .swiper-slide, :scope > .yotpo-redemption-item",
        navigate: function (dir) {
          var sw = getSwiper(ui.widget);
          if (sw) {
            if (dir < 0) sw.slidePrev();
            else sw.slideNext();
            return;
          }
          var amount = window.rbMobileCarouselArrows.cardStep(
            ui.track,
            ":scope > .rb-rewards__redeem-card, :scope > .swiper-slide, :scope > .yotpo-redemption-item"
          );
          if (amount) ui.track.scrollBy({ left: dir * amount, behavior: "smooth" });
        },
        getNavState: function () {
          var sw = getSwiper(ui.widget);
          if (sw) {
            return { atStart: !!sw.isBeginning, atEnd: !!sw.isEnd };
          }
          var maxScroll = Math.max(0, ui.track.scrollWidth - ui.track.clientWidth);
          var left = ui.track.scrollLeft;
          return { atStart: left <= 2, atEnd: left >= maxScroll - 2 || maxScroll <= 2 };
        }
      });
      window.rbMobileCarouselArrows.sync(ui.track, ui.rail);
    }

    var barWidth = ui.bar.clientWidth || ui.track.clientWidth || 1;
    var progress = 0;
    var thumbWidth = Math.max(THUMB_MIN, Math.round(barWidth * 0.34));
    var swiper = getSwiper(ui.widget);

    if (swiper && swiper.slides && swiper.slides.length > 1) {
      var slideCount = swiper.slides.length;
      thumbWidth = Math.max(THUMB_MIN, Math.round(barWidth / slideCount));
      if (typeof swiper.progress === "number" && !isNaN(swiper.progress)) {
        progress = Math.min(1, Math.max(0, swiper.progress));
      } else {
        progress = swiper.activeIndex / Math.max(1, slideCount - 1);
      }
    } else if (!trackOverflows(ui.track)) {
      ui.thumb.style.width = thumbWidth + "px";
      ui.thumb.style.transform = "translate3d(0, 0, 0)";
      return;
    } else {
      var maxScroll = Math.max(0, ui.track.scrollWidth - ui.track.clientWidth);
      thumbWidth = Math.max(
        THUMB_MIN,
        Math.round(barWidth * (ui.track.clientWidth / Math.max(ui.track.scrollWidth, 1)))
      );
      progress = maxScroll > 0 ? ui.track.scrollLeft / maxScroll : 0;
    }

    var maxOffset = Math.max(0, barWidth - thumbWidth);
    var targetX = progress * maxOffset;
    var snap = !!(options && options.snap);
    var state = ui.track._rbThumbSmooth || (ui.track._rbThumbSmooth = { x: targetX, target: targetX, raf: 0, width: 0 });

    if (state.width !== thumbWidth) {
      state.width = thumbWidth;
      ui.thumb.style.width = thumbWidth + "px";
    }

    state.target = targetX;
    if (snap) {
      if (state.raf) {
        window.cancelAnimationFrame(state.raf);
        state.raf = 0;
      }
      state.x = targetX;
      ui.thumb.style.transform = "translate3d(" + targetX + "px, 0, 0)";
      return;
    }

    if (state.raf) return;
    state.raf = window.requestAnimationFrame(function tick() {
      var delta = state.target - state.x;
      if (Math.abs(delta) < 0.2) {
        state.x = state.target;
        state.raf = 0;
      } else {
        state.x += delta * 0.45;
        state.raf = window.requestAnimationFrame(tick);
      }
      ui.thumb.style.transform = "translate3d(" + state.x + "px, 0, 0)";
    });
  }

  function equalizeHeights(track) {
    if (!track || !isMobile()) return;
    var cards = getCards(track);
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.style.minHeight = "";
    });
    var maxH = 0;
    cards.forEach(function (card) {
      maxH = Math.max(maxH, Math.ceil(card.getBoundingClientRect().height));
    });
    if (maxH < 1) return;
    cards.forEach(function (card) {
      card.style.minHeight = maxH + "px";
    });
  }

  function nudge(track) {
    if (prefersReducedMotion()) return;
    if (sessionStorage.getItem(NUDGE_KEY) === "1") return;
    if (!trackOverflows(track)) return;

    sessionStorage.setItem(NUDGE_KEY, "1");
    var peek = Math.min(36, Math.round(track.clientWidth * 0.08));
    track.scrollTo({ left: peek, behavior: "smooth" });
    window.setTimeout(function () {
      track.scrollTo({ left: 0, behavior: "smooth" });
    }, 420);
  }

  function bind() {
    if (!isMobile()) return;
    var widget = getWidget();
    if (!widget) return;
    var ui = ensureSwipe(widget);
    if (!ui) return;

    if (widget.dataset.rbRewardsRedeemBound === "1") {
      ui.cards = getCards(ui.track);
      tagTier(ui.track);
      equalizeHeights(ui.track);
      syncThumb(ui, { snap: true });
      return;
    }
    widget.dataset.rbRewardsRedeemBound = "1";

    var scrollRaf = 0;
    ui.track.addEventListener(
      "scroll",
      function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          syncThumb(ui);
        });
      },
      { passive: true }
    );
    ui.track.addEventListener(
      "scrollend",
      function () {
        syncThumb(ui, { snap: true });
      },
      { passive: true }
    );

    var swiper = getSwiper(widget);
    if (swiper && widget.dataset.rbRewardsRedeemSwiper !== "1") {
      widget.dataset.rbRewardsRedeemSwiper = "1";
      try {
        swiper.on("slideChange", function () {
          syncThumb(ui, { snap: true });
        });
        swiper.on("progress", function () {
          syncThumb(ui);
        });
        swiper.on("setTranslate", function () {
          syncThumb(ui);
        });
        swiper.on("touchMove", function () {
          syncThumb(ui);
        });
      } catch (e) {}
    }

    function refresh() {
      if (!isMobile()) return;
      var next = ensureSwipe(widget);
      if (!next) return;
      next.cards = getCards(next.track);
      tagTier(next.track);
      equalizeHeights(next.track);
      syncThumb(next, { snap: true });
    }

    refresh();
    window.setTimeout(refresh, 400);
    window.setTimeout(refresh, 1200);
    window.setTimeout(refresh, 2500);
    window.setTimeout(refresh, 5000);

    if (typeof MutationObserver !== "undefined" && widget.dataset.rbRewardsRedeemMo !== "1") {
      widget.dataset.rbRewardsRedeemMo = "1";
      var mo = new MutationObserver(function () {
        window.clearTimeout(widget._rbRedeemMoTimer);
        widget._rbRedeemMoTimer = window.setTimeout(function () {
          if (!widget.querySelector(".yotpo-redemption-options-list")) {
            widget.dataset.rbRewardsRedeemBound = "0";
            bind();
            return;
          }
          refresh();
        }, 120);
      });
      mo.observe(widget, { childList: true, subtree: true });
    }

    if (typeof IntersectionObserver !== "undefined") {
      var seen = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || seen || !isMobile()) return;
            seen = true;
            window.setTimeout(function () {
              nudge(ui.track);
              refresh();
            }, 350);
            io.disconnect();
          });
        },
        { threshold: 0.15 }
      );
      io.observe(widget);
    }
  }

  function onResize() {
    var widget = getWidget();
    if (!widget) return;
    if (!isMobile()) {
      var rail = widget.querySelector("[data-rb-rewards-redeem-rail]");
      if (rail) rail.setAttribute("hidden", "");
      return;
    }
    widget.dataset.rbRewardsRedeemBound = "0";
    bind();
  }

  bind();
  document.addEventListener("DOMContentLoaded", bind);
  window.addEventListener("load", bind);
  window.addEventListener("resize", onResize);
  window.setTimeout(bind, 800);
  window.setTimeout(bind, 2000);
  window.setTimeout(bind, 4000);
})();

/* Collection grid ? highlight most-visible card on mobile (same hover ring as Favorites) */
(function () {
  var MOBILE_MAX = 999;
  var scrollRaf = 0;
  var bound = false;

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function getGrid() {
    return document.querySelector(
      ".template-collection .t4s-main-collection-page .rb-product-cards, .template-collection .rb-product-cards"
    );
  }

  function syncActiveCard() {
    var grid = getGrid();
    if (!grid) return;

    var cards = grid.querySelectorAll(".rb-product");
    if (!cards.length) return;

    if (!isMobile()) {
      cards.forEach(function (card) {
        card.classList.remove("is-carousel-active");
      });
      return;
    }

    var focusY = window.innerHeight * 0.42;
    var focusX = window.innerWidth * 0.5;
    var best = null;
    var bestScore = Infinity;

    cards.forEach(function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      var visibleTop = Math.max(rect.top, 0);
      var visibleBottom = Math.min(rect.bottom, window.innerHeight);
      var visible = Math.max(0, visibleBottom - visibleTop);
      if (visible < Math.min(rect.height * 0.28, 80)) return;

      var cx = rect.left + rect.width * 0.5;
      var cy = rect.top + rect.height * 0.5;
      var score = Math.abs(cy - focusY) + Math.abs(cx - focusX) * 0.4 - visible * 0.12;
      if (score < bestScore) {
        bestScore = score;
        best = card;
      }
    });

    cards.forEach(function (card) {
      card.classList.remove("is-carousel-active");
    });
    if (best) best.classList.add("is-carousel-active");
  }

  function scheduleSync() {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = 0;
      syncActiveCard();
    });
  }

  window.rbSyncCollectionCardHighlight = scheduleSync;

  function bind() {
    if (!document.body.classList.contains("template-collection")) return;
    if (bound) {
      scheduleSync();
      return;
    }
    bound = true;

    window.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync);
    scheduleSync();

    var grid = getGrid();
    if (grid && typeof MutationObserver !== "undefined") {
      new MutationObserver(scheduleSync).observe(grid, { childList: true, subtree: false });
    }
  }

  bind();
  document.addEventListener("DOMContentLoaded", bind);
  window.addEventListener("load", function () {
    bind();
    scheduleSync();
  });
})();

/* Pin Accessibly beside Tidio — theme.liquid sets coords; JS only reparents once */
(function () {
  var SELECTOR = "#accessiblyAppWidgetButton";
  var moved = false;

  function ensureOnBody() {
    if (moved) return;
    var el = document.querySelector(SELECTOR);
    if (!el) return;
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    moved = true;
  }

  ensureOnBody();
  document.addEventListener("DOMContentLoaded", ensureOnBody);
  window.addEventListener("load", ensureOnBody);
  window.setTimeout(ensureOnBody, 1500);
})();

/* Pause decorative CSS animations while scrolling ? frees the compositor */
(function () {
  var MOBILE_MAX = 999;
  var CLASS = "rb-scroll-active";
  var IDLE_MS = 120;
  var timer = null;
  var active = false;

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function setActive(on) {
    if (on === active) return;
    active = on;
    document.documentElement.classList.toggle(CLASS, on);
  }

  function onScrollActivity(event) {
    if (!isMobile()) {
      setActive(false);
      return;
    }
    /* Horizontal review swipes fire touchmove — don't pause the whole page mid-flip */
    if (event && event.type === "touchmove") {
      var target = event.target;
      if (
        document.documentElement.classList.contains("rb-reviews-swiping") ||
        (target &&
          target.closest &&
          (target.closest(".rb-reviews") || target.closest("[data-rb-reviews-shell]")))
      ) {
        return;
      }
    }
    setActive(true);
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      setActive(false);
      timer = null;
    }, IDLE_MS);
  }

  window.addEventListener("scroll", onScrollActivity, { passive: true });
  window.addEventListener("touchmove", onScrollActivity, { passive: true });
  window.addEventListener("resize", function () {
    if (!isMobile()) setActive(false);
  });
})();

/* Mobile side cart: bag opens drawer; /cart is desktop-only */
(function () {
  var MOBILE_MAX = 999;
  var loadingPromise = null;
  var FETCH_MS = 8000;

  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }

  function cartEl() {
    return document.getElementById("t4s-mini_cart");
  }

  function isSkeleton(el) {
    return !!(el && el.querySelector(".t4s-skeleton-element"));
  }

  function cartIsReady(el) {
    if (!el || isSkeleton(el)) return false;
    // Header alone is not enough — that looks like a blank side cart.
    return !!(
      el.querySelector(".t4s-drawer__wrap") ||
      el.querySelector("[data-cart-items]") ||
      el.querySelector(".t4s-mini_cart__emty")
    );
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = window.setTimeout(function () {
        if (done) return;
        done = true;
        reject(new Error("mini_cart timeout"));
      }, ms);
      promise.then(
        function (v) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          resolve(v);
        },
        function (err) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          reject(err);
        }
      );
    });
  }

  function sectionFetchUrl(mode) {
    var params = new URLSearchParams(window.location.search);
    var preview = params.get("preview_theme_id");
    var qs =
      mode === "json"
        ? "sections=mini_cart"
        : "section_id=mini_cart";
    if (preview) qs += "&preview_theme_id=" + encodeURIComponent(preview);
    qs += "&_rb=" + Date.now();
    var root = (window.T4SThemeSP && T4SThemeSP.root_url) || "/";
    if (root.slice(-1) !== "/") root += "/";
    return root + "?" + qs;
  }

  function unwrapCartHtml(html) {
    if (!html || typeof html !== "string") return "";
    var doc = new DOMParser().parseFromString(html, "text/html");
    /* Sections API wraps markup in .shopify-section — nesting that inside #t4s-mini_cart
       collapses the product list (flex child only ~200px, main height 0). */
    var section =
      doc.querySelector("#shopify-section-mini_cart") ||
      doc.querySelector("[id^='shopify-section-']");
    if (section) {
      var nestedCart = section.querySelector("#t4s-mini_cart");
      if (nestedCart) return nestedCart.innerHTML;
      return section.innerHTML;
    }
    var onlyCart = doc.querySelector("#t4s-mini_cart");
    if (onlyCart) return onlyCart.innerHTML;
    return html;
  }

  function extractSectionHtml(payload) {
    if (!payload) return "";
    if (typeof payload === "object" && payload.mini_cart) {
      return unwrapCartHtml(payload.mini_cart);
    }
    if (typeof payload !== "string") return "";
    if (payload === "NVT_94") return "";
    return unwrapCartHtml(payload);
  }

  function layoutCartShell(el) {
    if (!el) return;
    el.style.display = "flex";
    el.style.flexDirection = "column";
    el.style.height = "100dvh";
    el.style.maxHeight = "100dvh";
    el.style.overflow = "hidden";
    var wrap = el.querySelector("form.t4s-drawer__wrap");
    if (wrap) {
      wrap.style.display = "flex";
      wrap.style.flexDirection = "column";
      wrap.style.flex = "1 1 0";
      wrap.style.minHeight = "0";
      wrap.style.height = "auto";
      wrap.style.overflow = "hidden";
    }
    var main = el.querySelector(".t4s-drawer__main");
    if (main) {
      main.style.position = "relative";
      main.style.flex = "1 1 0";
      main.style.minHeight = "0";
      main.style.overflow = "hidden";
      main.style.pointerEvents = "auto";
    }
    var scroller = el.querySelector(".t4s-drawer__scroll, [data-t4s-scroll-me]");
    if (scroller) {
      scroller.style.position = "absolute";
      scroller.style.top = "0";
      scroller.style.right = "0";
      scroller.style.bottom = "0";
      scroller.style.left = "0";
      scroller.style.maxHeight = "100%";
      scroller.style.overflowY = "scroll";
      scroller.style.webkitOverflowScrolling = "touch";
      scroller.style.pointerEvents = "auto";
      scroller.style.touchAction = "pan-y";
    }
    var bottom = el.querySelector(".t4s-drawer__bottom");
    if (bottom) {
      bottom.style.flex = "0 0 auto";
      bottom.style.marginTop = "auto";
      bottom.style.marginBottom = "0";
      bottom.style.paddingBottom = "15px";
      bottom.style.transform = "none";
      bottom.style.opacity = "1";
    }
  }

  function applyCartHtml(el, html) {
    if (!el || !html || html.indexOf("t4s-skeleton-element") !== -1) return false;
    html = unwrapCartHtml(html);
    if (
      html.indexOf("t4s-drawer__wrap") === -1 &&
      html.indexOf("rb-side-cart__header") === -1 &&
      html.indexOf("t4s-mini_cart__emty") === -1
    ) {
      return false;
    }
    el.innerHTML = html;
    /* If anything still nested a section wrapper, hoist its children */
    var stray = el.querySelector(":scope > .shopify-section, :scope > [id^='shopify-section-']");
    if (stray) {
      while (stray.firstChild) el.insertBefore(stray.firstChild, stray);
      stray.remove();
    }
    el.classList.remove("is--contentUpdate");
    el.style.display = "";
    el.setAttribute("data-rb-cart-ready", "1");
    layoutCartShell(el);
    var countEl = document.querySelector("[data-cart-count]");
    var ccount = el.getAttribute("data-ccount");
    if (countEl && ccount != null && ccount !== "") {
      countEl.textContent = ccount;
      if (parseInt(ccount, 10) > 0) countEl.removeAttribute("hidden");
      else countEl.setAttribute("hidden", "");
    }
    try {
      if (window.jQuery) jQuery(document).trigger("currency:update");
      if (window.T4SThemeSP && T4SThemeSP.Tooltip) T4SThemeSP.Tooltip();
      if (window.T4SThemeSP && T4SThemeSP.ProductAjax && T4SThemeSP.ProductAjax.change) {
        T4SThemeSP.ProductAjax.change();
      }
    } catch (err) {}
    return cartIsReady(el);
  }

  function injectFallback(el) {
    if (!el) return false;
    el.innerHTML =
      '<div class="t4s-drawer__header rb-side-cart__header">' +
      '<span class="rb-side-cart__logo" aria-hidden="true"></span>' +
      '<button class="t4s-drawer__close" data-drawer-close aria-label="Close">' +
      '<svg class="t4s-iconsvg-close" role="presentation" viewBox="0 0 16 14">' +
      '<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>' +
      "</svg></button></div>" +
      '<form action="/cart" method="post" class="t4s-drawer__wrap">' +
      '<div class="t4s-drawer__body"><div class="t4s-mini_cart__emty">' +
      "<h4>Your cart is empty</h4>" +
      '<a href="/collections/shop-all-kratom" class="t4s-btn">Continue shopping</a>' +
      "</div></div></form>";
    el.classList.remove("is--contentUpdate");
    el.style.display = "";
    el.setAttribute("data-rb-cart-ready", "1");
    return true;
  }

  function fetchMiniCartHtml() {
    var jsonUrl = sectionFetchUrl("json");
    var textUrl = sectionFetchUrl("text");

    return withTimeout(
      fetch(jsonUrl, {
        method: "GET",
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) {
        if (!res.ok) throw new Error("json " + res.status);
        return res.json();
      }),
      FETCH_MS
    )
      .then(function (data) {
        var html = extractSectionHtml(data);
        if (!html) throw new Error("json empty");
        return html;
      })
      .catch(function () {
        return withTimeout(
          fetch(textUrl, {
            method: "GET",
            credentials: "same-origin",
            headers: { Accept: "text/html", "Cache-Control": "no-cache" }
          }).then(function (res) {
            if (!res.ok) throw new Error("text " + res.status);
            return res.text();
          }),
          FETCH_MS
        ).then(function (html) {
          var out = extractSectionHtml(html);
          if (!out) throw new Error("text empty");
          return out;
        });
      });
  }

  function loadMiniCart(force) {
    var el = cartEl();
    if (!el) return Promise.resolve(false);
    if (!force && cartIsReady(el)) return Promise.resolve(true);
    /* force must not reuse an in-flight stale (often empty) request */
    if (loadingPromise && !force) return loadingPromise;

    var req = fetchMiniCartHtml()
      .then(function (html) {
        return applyCartHtml(el, html);
      })
      .catch(function (err) {
        console.warn("[rb] mini cart load failed", err);
        if (cartIsReady(el)) return true;
        return injectFallback(el);
      })
      .finally(function () {
        if (loadingPromise === req) loadingPromise = null;
      });

    loadingPromise = req;
    return req;
  }

  /* Theme Helpers.disableBodyScroll is a factory — cache the real locker so unlock matches. */
  var bodyScrollLocker = null;
  var unlockTimers = [];
  var pageScrollLocked = false;

  function getBodyScrollLocker() {
    if (bodyScrollLocker) return bodyScrollLocker;
    try {
      var helpers = window.T4SThemeSP && T4SThemeSP.Helpers;
      if (!helpers || typeof helpers.disableBodyScroll !== "function") return null;
      /* IMPORTANT: call factory with no side-effect lock; never pass (true/false) into the factory. */
      var result = helpers.disableBodyScroll();
      if (typeof result === "function") {
        bodyScrollLocker = result;
      } else {
        bodyScrollLocker = null;
      }
    } catch (err) {
      bodyScrollLocker = null;
    }
    return bodyScrollLocker;
  }

  function clearUnlockTimers() {
    while (unlockTimers.length) {
      window.clearTimeout(unlockTimers.pop());
    }
  }

  function unlockPageScroll() {
    var html = document.documentElement;
    var body = document.body;
    html.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    html.style.overflow = "";
    html.style.touchAction = "";
    body.style.overflow = "";
    body.style.touchAction = "";
    body.style.position = "";
    body.style.top = "";
    body.style.width = "";
    body.style.height = "";
    var overlay = document.querySelector(".t4s-close-overlay");
    if (overlay) {
      overlay.classList.remove("is--visible", "is--pindop");
      overlay.style.zIndex = "";
      overlay.style.pointerEvents = "none";
      overlay.style.display = "";
    }
    try {
      var locker = getBodyScrollLocker();
      if (locker) locker(false, "[data-t4s-scroll-me]");
    } catch (err) {}
    pageScrollLocked = false;
  }

  function lockPageScroll() {
    clearUnlockTimers();
    document.documentElement.classList.add("t4s-lock-scroll", "is--opend-drawer");
    try {
      var locker = getBodyScrollLocker();
      if (locker) locker(true, "[data-t4s-scroll-me]");
    } catch (err) {}
    pageScrollLocked = true;
  }

  function isSideCartOpen() {
    var el = cartEl();
    return !!(el && (el.classList.contains("is--opend") || el.getAttribute("aria-hidden") === "false"));
  }

  function isAnyThemeDrawerOpen() {
    return !!document.querySelector(".t4s-drawer[aria-hidden='false']");
  }

  /* Theme drawers often unlock on transitionend — if that never fires, scroll stays dead. */
  function recoverStuckPageScroll() {
    if (isSideCartOpen() || isAnyThemeDrawerOpen()) return;
    /* Leave third-party search/modals alone if they set overflow without our classes */
    if (
      document.querySelector(
        '.x-predictive-search.is-open, [class*="PredictiveSearch"].is-open, .foxify-search-modal[aria-hidden="false"]'
      )
    ) {
      return;
    }
    if (
      pageScrollLocked ||
      document.documentElement.classList.contains("t4s-lock-scroll") ||
      document.body.classList.contains("t4s-lock-scroll") ||
      document.documentElement.classList.contains("is--opend-drawer") ||
      document.body.classList.contains("is--opend-drawer")
    ) {
      unlockPageScroll();
    }
  }

  window.addEventListener("pageshow", recoverStuckPageScroll);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") recoverStuckPageScroll();
  });
  /* First touch after a stuck lock — recover without waiting for navigation */
  document.addEventListener(
    "touchstart",
    function () {
      recoverStuckPageScroll();
    },
    { passive: true, capture: true }
  );

  function revealMiniCart(el) {
    if (!el) return;
    clearUnlockTimers();
    el.classList.remove("t4s-dn", "is--contentUpdate");
    el.classList.add("is--opend");
    el.setAttribute("aria-hidden", "false");
    el.style.display = "flex";
    el.style.flexDirection = "column";
    el.style.transform = "translate3d(0,0,0)";
    el.style.webkitTransform = "translate3d(0,0,0)";
    el.style.opacity = "1";
    el.style.visibility = "visible";
    el.style.pointerEvents = "auto";
    el.style.touchAction = "pan-y";
    lockPageScroll();
    layoutCartShell(el);
    var overlay = document.querySelector(".t4s-close-overlay");
    if (overlay) {
      overlay.classList.add("is--visible");
      overlay.style.display = "";
      overlay.style.pointerEvents = "auto";
      overlay.style.zIndex = "10000040";
    }
  }

  function hideMiniCart() {
    var el = cartEl();
    if (!el) return;
    el.classList.add("t4s-dn");
    el.classList.remove("is--opend");
    el.setAttribute("aria-hidden", "true");
    el.style.display = "none";
    el.style.transform = "";
    el.style.webkitTransform = "";
    el.style.opacity = "";
    el.style.visibility = "";
    el.style.pointerEvents = "";
    el.style.touchAction = "";
    /* Unlock immediately — do not wait for theme transitionend (display:none kills it). */
    unlockPageScroll();
    /* Soft-reset theme drawer flag without relying on its unlock path */
    try {
      if (window.T4SThemeSP && T4SThemeSP.Drawer && typeof T4SThemeSP.Drawer.close === "function") {
        T4SThemeSP.Drawer.close(window.jQuery ? window.jQuery(el) : el);
      }
    } catch (err) {}
    unlockPageScroll();
    clearUnlockTimers();
    unlockTimers.push(window.setTimeout(unlockPageScroll, 0));
    unlockTimers.push(window.setTimeout(unlockPageScroll, 350));
  }

  function openMiniCart() {
    var el = cartEl();
    if (!el) return false;
    /* Own open/close fully on mobile — theme Drawer.opend re-locks and races our close. */
    revealMiniCart(el);
    return true;
  }

  /* X + dim overlay must close even when we forced the drawer open */
  document.addEventListener(
    "click",
    function (e) {
      if (!isMobile()) return;
      var closeBtn = e.target.closest("#t4s-mini_cart [data-drawer-close], #t4s-mini_cart .t4s-drawer__close");
      var overlay = e.target.closest(".t4s-close-overlay.is--visible");
      if (!closeBtn && !overlay) return;
      e.preventDefault();
      e.stopPropagation();
      hideMiniCart();
    },
    true
  );

  /* Sidecart + tap: force green while pressed (iOS often skips :active) */
  (function bindQtyPlusPress() {
    var pressTimer = null;
    function clearPress(btn) {
      if (!btn) return;
      btn.classList.remove("is-pressing");
    }
    document.addEventListener(
      "touchstart",
      function (e) {
        if (!isMobile()) return;
        var btn = e.target.closest("#t4s-mini_cart .t4s-quantity-cart-item button.is--plus");
        if (!btn) return;
        btn.classList.add("is-pressing");
        if (pressTimer) window.clearTimeout(pressTimer);
        pressTimer = window.setTimeout(function () {
          clearPress(btn);
        }, 280);
      },
      { passive: true, capture: true }
    );
    document.addEventListener(
      "touchend",
      function (e) {
        var btn = e.target.closest("#t4s-mini_cart .t4s-quantity-cart-item button.is--plus");
        if (!btn) return;
        if (pressTimer) window.clearTimeout(pressTimer);
        pressTimer = window.setTimeout(function () {
          clearPress(btn);
        }, 180);
      },
      { passive: true, capture: true }
    );
    document.addEventListener(
      "touchcancel",
      function (e) {
        var btn = e.target.closest("#t4s-mini_cart .t4s-quantity-cart-item button.is--plus");
        clearPress(btn);
      },
      { passive: true, capture: true }
    );
  })();

  document.addEventListener("keydown", function (e) {
    if (!isMobile() || e.key !== "Escape") return;
    var el = cartEl();
    if (!el || el.getAttribute("aria-hidden") === "true") return;
    hideMiniCart();
  });

  function openMobileCart(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    /* Always re-fetch so line items match the live cart */
    loadMiniCart(true)
      .then(function () {
        return fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            var node = cartEl();
            var domItems = node
              ? node.querySelectorAll(".t4s-mini_cart__item").length
              : 0;
            if (cart && cart.item_count > 0 && domItems === 0) {
              return loadMiniCart(true);
            }
          })
          .catch(function () {});
      })
      .then(function () {
        openMiniCart();
      });
  }

  /* Disable theme auto-drawer on the bag so we never open a skeleton */
  function disarmThemeCartDrawer() {
    document.querySelectorAll("[data-rb-cart-trigger]").forEach(function (link) {
      link.removeAttribute("data-drawer-options");
      link.removeAttribute("data-drawer-delay");
      link.removeAttribute("data-drawer-delay-");
    });
  }

  /* Bag click: mobile ? side cart; desktop ? /cart */
  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest("[data-rb-cart-trigger], a[data-drawer-options*='mini_cart'], a[href='/cart']");
      if (!link) return;
      if (link.closest(".t4s-drawer__bottom, #t4s-mini_cart, .t4s-page_cart")) return;

      var isBag = link.hasAttribute("data-rb-cart-trigger") ||
        (link.getAttribute("data-drawer-options") || "").indexOf("mini_cart") !== -1 ||
        link.classList.contains("rb-header__cart");

      if (!isBag && (link.getAttribute("href") || "") !== "/cart") return;

      if (isMobile()) {
        openMobileCart(e);
        return;
      }

      if (link.hasAttribute("data-rb-cart-trigger") || link.classList.contains("rb-header__cart")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = link.getAttribute("href") || "/cart";
      }
    },
    true
  );

  /* If theme Drawer tries to open an empty/skeleton cart on mobile, load first */
  function patchDrawerOpen() {
    if (!window.T4SThemeSP || !T4SThemeSP.Drawer || T4SThemeSP.Drawer.__rbCartPatched) return;
    var original = T4SThemeSP.Drawer.opend;
    if (typeof original !== "function") return;
    T4SThemeSP.Drawer.__rbCartPatched = true;
    T4SThemeSP.Drawer.opend = function (target) {
      var node = target && target.jquery ? target[0] : target;
      var id = node && (node.id || (node.getAttribute && node.getAttribute("id")));
      if (isMobile() && id === "t4s-mini_cart" && !cartIsReady(cartEl())) {
        loadMiniCart(true).then(function () {
          original.call(T4SThemeSP.Drawer, target);
        });
        return;
      }
      return original.call(T4SThemeSP.Drawer, target);
    };
  }

  /* Mobile /cart ? home + open side cart (keep preview params) */
  if (document.body.classList.contains("template-cart") && isMobile()) {
    var params = new URLSearchParams(window.location.search);
    params.set("rb_open_cart", "1");
    window.location.replace("/?" + params.toString());
    return;
  }

  function openFromQuery() {
    if (!isMobile()) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get("rb_open_cart") !== "1") return;
    params.delete("rb_open_cart");
    var qs = params.toString();
    var clean = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
    history.replaceState(null, "", clean);

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      loadMiniCart(tries === 1).then(function (ok) {
        if (ok && openMiniCart()) window.clearInterval(timer);
        else if (tries > 20) {
          window.clearInterval(timer);
          injectFallback(cartEl());
          openMiniCart();
        }
      });
    }, 200);
  }

  function warm() {
    if (!isMobile()) return;
    disarmThemeCartDrawer();
    patchDrawerOpen();
    loadMiniCart(true);
    /* Theme Cart.init can finish later with NVT_94 and leave skeleton ? re-check */
    window.setTimeout(function () {
      if (isSkeleton(cartEl())) loadMiniCart(true);
    }, 1500);
    window.setTimeout(function () {
      if (isSkeleton(cartEl())) loadMiniCart(true);
    }, 4000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      warm();
      openFromQuery();
    });
  } else {
    warm();
    openFromQuery();
  }
  window.addEventListener("load", function () {
    patchDrawerOpen();
    if (isMobile() && isSkeleton(cartEl())) loadMiniCart(true);
  });
})();


/* Phone-stage PDP: destroy desktop isotope gallery if theme enabled it (rb-phone-stage-pdp-999-v1) */
(function () {
  var MOBILE_MAX = 999;
  function isMobile() {
    return window.rbIsTouchMobile(MOBILE_MAX);
  }
  function killIsotope() {
    if (!isMobile() || !document.body.classList.contains("template-product")) return;
    var media = document.querySelector("[data-main-media].isotopet4s-enabled, [data-main-media].isotopet4s");
    if (!media) return;
    try {
      if (window.jQuery && jQuery.fn && jQuery.fn.isotopet4s && jQuery(media).hasClass("isotopet4s-enabled")) {
        jQuery(media).isotopet4s("destroy").removeClass("isotopet4s-enabled");
      } else {
        media.classList.remove("isotopet4s-enabled");
      }
    } catch (err) {}
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", killIsotope);
  } else {
    killIsotope();
  }
  window.addEventListener("resize", killIsotope, { passive: true });
  window.setTimeout(killIsotope, 400);
  window.setTimeout(killIsotope, 1200);
})();
